// Things one page hands the next when it navigates: kept in memory, read once, so a reload or a later visit starts clean.

let selection: { projectId: number; ids: number[] } | null = null;
let galleryView: { projectId: number; view: GalleryView } | null = null;

/** The dashboard's selected images, for the Augment page it is about to open. */
export const handOffSelection = (projectId: number, ids: number[]) => { selection = { projectId, ids }; };
export function takeSelection(projectId: number): number[] {
  const s = selection; selection = null;
  return s && s.projectId === projectId ? s.ids : [];
}

/** What the dashboard's gallery opens on: a folder (Augment ▸ Show these images), a status (Auto-annotate ▸ Review now). */
export interface GalleryView { folder?: string | null; status?: string | null }
export const showInGallery = (projectId: number, view: GalleryView) => { galleryView = { projectId, view }; };
export function takeGalleryView(projectId: number): GalleryView | undefined {
  const g = galleryView; galleryView = null;
  return g && g.projectId === projectId ? g.view : undefined;
}
